// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"c81ecc76","356":"1644741c","385":"306609c9","574":"677b3a3b","791":"83b2b998","793":"ceb9789c","807":"3bb7a2c9"}[chunkId] + ".chunk.js";
};